import { useContext, useState } from "react";

import NTCoachOfRecordData from "./NTCoachOfRecordData";
import { NTCoachOfRecordContext } from "./NTCoachOfRecordContextProvider";

const useNTCoachOfRecordData = () => {
  const [nationalTeamCoachOfRecordState, setNationalTeamCoachOfRecordState] = useContext(NTCoachOfRecordContext);
  const [nationalTeamCoachRegistrationState, setNationalTeamCoachRegistrationState] = useState(NTCoachOfRecordData.INITIAL_NT_COACH_REGISTRATION_STATE);
  const [coachOfRecordAddState, setCoachOfRecordAddState] = useState(NTCoachOfRecordData.INITIAL_COACH_OF_RECORD_ADD_STATE)
  const [coachRegistrationState, setCoachRegistrationState] = useState(NTCoachOfRecordData.INITIAL_COACH_REGISTRATION_STATE);

  const postNTCoachOfRecord = (personId, coachObj) => {
    return NTCoachOfRecordData.postNTCoachOfRecordData(personId, coachObj, coachOfRecordAddState, setCoachOfRecordAddState);
  };

  const getNTCoachOfRecord = (personId) => {
    return NTCoachOfRecordData.getNTCoachOfRecordData(personId, nationalTeamCoachOfRecordState, setNationalTeamCoachOfRecordState);
  };

  const getNTCoachRegistration = (personNationalTeamGroupId) => {
    return NTCoachOfRecordData.getNTCoachRegistrationData(personNationalTeamGroupId, nationalTeamCoachRegistrationState, setNationalTeamCoachRegistrationState);
  };

  const putNTCoachRegistration = (personNationalTeamGroupId, coachRegistrationObj) => {
    return NTCoachOfRecordData.putNTCoachRegistrationData(personNationalTeamGroupId, coachRegistrationObj, coachRegistrationState, setCoachRegistrationState);
  };

  return {
    nationalTeamCoachOfRecordState,
    nationalTeamCoachRegistrationState,
    coachOfRecordAddState,
    coachRegistrationState,
    postNTCoachOfRecord,
    getNTCoachOfRecord,
    getNTCoachRegistration,
    putNTCoachRegistration
  };
};

export default useNTCoachOfRecordData;